import { Column } from "../../../../core/components/Column";
import { Ref } from "../../../../core/components/Ref";
import { Row } from "../../../../core/components/Row";
import { SectionCard } from "../../../../core/components/SectionCard";
import { StartSection } from "../../../../core/components/StartSection";
import { TextComponent } from "../../../../core/components/TextComponent";
import { getNameSocialNetwork } from "../../../../core/constants/utils";
import guiaInvitadosData from "../../../../core/data/db_guia_invitados.json";
import { FacebookIcon } from "../../../../core/icons/Facebook";
import { InstagramIcon } from "../../../../core/icons/Instagram";
import { WebIcon } from "../../../../core/icons/Web";

export const TouristBus: React.FC = () => {
	const touristBusSection = guiaInvitadosData.guia_para_invitados.mirabus;
	const touristBus = Array.isArray(touristBusSection.contenido) ? touristBusSection.contenido : [];

	if (touristBus.length === 0) {
		return (
			<TextComponent
				variant="h6"
				className="text-center text-gray-500"
			>
				No hay mirabuses disponibles.
			</TextComponent>
		);
	}

	return (
		<>
			<StartSection
				titulo={touristBusSection.titulo}
				backgroundImage="mirabus.jpg"
			/>
			<main className="self-center w-full sm:w-[40rem] md:w-[90%] xl:w-[60rem] mb-4 sm:mb-8">
				<Column
					crossAxisAlignment="center"
					className="bg-white py-5 px-5 gap-4 sm:gap-8 min-h-screen"
				>
					<TextComponent
						variant="h6"
						className="text-center text-gray-700"
					>
						{touristBusSection.descripcion}
					</TextComponent>

					<Column className="grid grid-cols-1 sm:grid-cols-2 w-full gap-4 sm:gap-8">
						{touristBus.map((mirabus, index) => {
							const nameSocialNetwork = getNameSocialNetwork(mirabus.red_social);
							const color = (() => {
								switch (nameSocialNetwork) {
									case "Instagram":
										return "instagram";
									case "Facebook":
										return "facebook";
									default:
										return "mutedViolet";
								}
							})();

							return (
								<SectionCard
									key={index}
									index={index}
									img={mirabus.img}
									titulo={mirabus.nombre}
									descripcion={mirabus.descripcion}
									classNameImg="w-2/6 sm:w-2/6 md:w-2/5 aspect-square object-cover rounded-md"
									responsive={false}
								>
									<Column className="text-gray-600">
										<TextComponent
											variant="h6"
											className="text-black"
										>
											Consultas:
										</TextComponent>
										<Row
											crossAxisAlignment="center"
											className="gap-4"
										>
											<Row
												crossAxisAlignment="center"
												className="gap-0.5"
											>
												<TextComponent variant="h6">{mirabus.referencia_ubicacion}</TextComponent>
											</Row>
										</Row>
									</Column>
									<Ref
										href={mirabus.red_social}
										target="_blank"
										className="w-fit self-end font-bold mt-auto"
										size="sm"
										color={color}
										secondary
									>
										<Row
											className="gap-0.5"
											mainAxisAlignment="center"
											crossAxisAlignment="center"
										>
											{(() => {
												switch (nameSocialNetwork) {
													case "Instagram":
														return (
															<InstagramIcon
																className="w-4 h-4"
																stroke="2.5"
															/>
														);
													case "Facebook":
														return (
															<FacebookIcon
																className="w-4 h-4"
																stroke="2.5"
															/>
														);
													default:
														return (
															<WebIcon
																className="w-4 h-4"
																stroke="2.5"
															/>
														);
												}
											})()}

											<TextComponent variant="h7">Ver en {nameSocialNetwork}</TextComponent>
										</Row>
									</Ref>
								</SectionCard>
							);
						})}
					</Column>
				</Column>
			</main>
		</>
	);
};
